import { useState } from "react";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { Alert, Box, Button, Divider, TextField, Typography } from "@mui/material";
import { Card, Section } from "../components/ui";
import { useAuth0 } from "../hooks/useAuth0";
import { COGNITO_CONFIGURED } from "../services/cognitoAuthService";
import { tokens } from "../theme";

export default function Login() {
  const { signInWithEmail, signInWithGoogle, signInWithApple } = useAuth0();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await signInWithEmail(email.trim(), password);
      navigate("/dashboard", { replace: true });
    } catch (err) {
      setError(err?.message || "Could not sign in.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Section tone="sage" narrow sx={{ minHeight: "70vh" }}>
      <Card sx={{ maxWidth: 460, mx: "auto" }}>
        <Typography variant="h3" sx={{ fontSize: 32 }}>Log in</Typography>
        {!COGNITO_CONFIGURED && (
          <Alert severity="info" sx={{ mt: 2 }}>
            Sign-in is not configured in this preview. You can still <RouterLink to="/sample-dashboard">view the sample dashboard</RouterLink>.
          </Alert>
        )}
        {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
        <Box component="form" onSubmit={submit} sx={{ display: "grid", gap: 2, mt: 3 }}>
          <TextField label="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoComplete="email" />
          <TextField label="Password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required autoComplete="current-password" />
          <Button type="submit" variant="contained" size="large" disabled={busy || !COGNITO_CONFIGURED}>{busy ? "Signing in..." : "Log in"}</Button>
        </Box>
        <Divider sx={{ my: 3 }}>or</Divider>
        <Box sx={{ display: "grid", gap: 1.5 }}>
          <Button variant="outlined" onClick={signInWithGoogle} disabled={!COGNITO_CONFIGURED}>Continue with Google</Button>
          <Button variant="outlined" onClick={signInWithApple} disabled={!COGNITO_CONFIGURED}>Continue with Apple</Button>
        </Box>
        <Typography sx={{ mt: 3, fontSize: 14, color: tokens.muted }}>
          <RouterLink to="/forgot-password">Forgot password?</RouterLink> · New to VEYSO? <RouterLink to="/signup">Create an account</RouterLink>
        </Typography>
      </Card>
    </Section>
  );
}
